import colors from '../sass/colors';
import dimensions from '../sass/dimensions';

export default {
  colors,
  dimensions
};
